"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Concatenate the 'Standard Imperial Prefix Abbreviation' to the end of the count
 * @param num
 */
exports.ToSIPrefix = (num) => {
    if (num < 1000)
        return num;
    const toLocale = (num) => num.toLocaleString('de-DE', { maximumFractionDigits: 1 });
    const toMagnitude = (num) => (num > 999999 ? 'M' : 'K');
    const str = toLocale(num);
    return str.substring(0, str.indexOf('.') + 2) + toMagnitude(num);
};
